import React, { useEffect, useState } from "react";

import { v4 as uuidv4 } from "uuid";
import {
  Button,
  CustomFileInput,
  CustomInput,
  Divider,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  InvoiceSidebar,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../components";
import {
  CreateInvoiceByOptions,
  InvoiceClientOptions,
  InvoiceEmployeesOptions,
  InvoiceFrequencyOptions,
  netTermsOptions,
} from "../../../../assets/data/projectData";
import FromToDateModal from "../Addinvoives/Modal/FromToDateModal";
import { useDispatch } from "react-redux";
import common from "../../../../utils/common";
import { useNavigate } from "react-router-dom";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import { addInvoicesStart, getCurrentInvoiceStart } from "../../../../redux/slices/invoices/invoicesSlice";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";

const EditInvoice = ({ onBack, currentInvoices }) => {
  const {
    splitByCase,
    mapDailyEntriesToRanges,
    calculateDiscountedTotal,
    mergeEntries,
    formatDiscountDisplay,
    calculateTotalDiscountInvoice,
  } = common;
  const dispatch = useDispatch();
  const [moreActionModal, setMoreActionModal] = useState(false);
  const [showfromToDate, setShowfromToDate] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const { userData: loginUserData } = useLoginUser();
  const defaultValues = {
    createInvoiceBy: "",
    client: "",
    invoiceFrequency: "",
    fromToDate: "",
    intervals: "",
    employees: "",
    billingAddress: " ",
    fromAddress: `TekTree LLC
1106 Drummond Plaza
Newark, DE 19711
accounts@tektreeinc.com
www.tektreeinc.com
`,
    additionalInfo: "",
    netTerms: "",
    invoiceDate: "",
    shippedDate: "",
    dueDate: "",
    location: "",
    class: "",
    invoiceNumber: "",
    pONumber: "",
    includePOAttachment: [],
    contactEmail: [],
    ccEmail: [],
    bccEmail: [],
    consultantName: "",
    discounts: [
      {
        id: uuidv4(),
        ss: "",
        select: 1,
        activity: "",
        type: 1,
        discount: "",
        quantity: 0,
        amount: 0,
        rate: 0,
      },
    ],
    notes: "",
    statementMemo: "",
    includeNotesInInvoice: [],
    // statementMemoFrom: "",
    // statementMemoTo: "",
    statementMemoFromTo: "",
    invoiceCetegoty: "",
    attachment: [],
    payableTo: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValues, {});

  const [tableData, setTableData] = useState([]);
  const [placementsUiid, setPlacementsUiid] = useState([]);
  const [entityType, setEntityType] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [allEmployeePlacementsList, setAllEmployeePlacementsList] = useState(
    []
  );
  const [selectEmployeePlacement, setSelectEmployeePlacement] = useState({});
  const [selectClientOptions, setSelectClientOptions] = useState([]);
  // / timesheetData
  const [selectTimeSheetData, setSelectTimeSheetData] = useState([]);
  const [selectTimeSheetOriganalData, setSelectTimeSheetOriganalData] =
    useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [latestUiid, setLatestUiid] = useState();
  //

  const tableAmountTotal = tableData.reduce(
    (sum, entry) => sum + Number(entry.amount || 0),
    0
  );
  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    const checkFile =
      field === "attachment"
        ? Array.isArray(value)
          ? value
          : [value] // always wrap single file in array
        : newValue;
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: checkFile || "" } : row
      )
    );
  };

  // const handleAddRow = () => {
  //   // if (isEdit) {
  //   const newRow = {
  //     id: uuidv4(),
  //     ss: "",
  //     activity: "",
  //     quantity: 0,
  //     amount: 0,
  //     rate: 0,
  //     attachment: [],
  //     editing: true,
  //     editable: true,
  //     delete: true,
  //   };
  //   setTableData((prev) => [...prev, newRow]);
  //   // }
  // };

  // const handleRemoveRow = (rowId) => {
  //   setTableData((prev) => {
  //     const updatedRows = prev.filter((row) => row.id !== rowId);
  //     return updatedRows.length > 0 ? updatedRows : prev;
  //   });
  // };
  const handleEditRow = (rowId) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, editing: !row.editing } : row
      )
    );
  };

  const columns = [
    {
      key: "ss",
      label: "Service Summary",
      render: (row) => (
        <div>
          {row.editing ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter Name"
              value={row.ss || ""}
              onChange={(value) => handleRowChange(row.id, "ss", value)}
            />
          ) : (
            <span>{row.ss}</span>
          )}
        </div>
      ),
    },
    {
      key: "activity",
      label: "Activity",
      render: (row) => (
        <div>
          {row.editing ? (
            <CustomInput
              type="text"
              placeholder="Enter details"
              title=""
              size="xs"
              value={row?.activity || ""}
              onChange={(value) => handleRowChange(row.id, "activity", value)}
            />
          ) : (
            <span>{row?.activity}</span>
          )}
        </div>
      ),
    },
    {
      key: "quantity",
      label: "Quality(Hrs/days)",
      render: (row) => (
        <div>
          <span>{row.quantity}</span>
        </div>
      ),
    },
    {
      key: "rate",
      label: "Rate",
      render: (row) => (
        <div>
          <span>{row.rate}</span>
        </div>
      ),
    },

    {
      key: "amount",
      label: "Amount",
      render: (row) => (
        <div>
          <span>{row.amount}</span>
        </div>
      ),
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div>
          {row.editing ? (
            <CustomFileInput
              type="file"
              placeholder="choose file"
              title=""
              size="xs"
              value={row?.attachment || []}
              // onChange={(value) => handleRowChange(row.id, "attachment", value)}
              onChange={(file) => handleRowChange(row.id, "attachment", file)}
              key={row.id}
            />
          ) : (
            <span>{row.attachment?.[0]?.name || ""}</span>
          )}
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          {row.editable === true && (
            <Button
              type="icon"
              icon={row.editing ? "save" : "edit_square"}
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleEditRow(row.id)}
            />
          )}
          {/* {row.delete === true && (
            <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleRemoveRow(row.id)}
            />
          )} */}
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={() => setMoreActionModal(!moreActionModal)}
          />
        </div>
      ),
    },
  ];

  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: formData?.discounts?.[0]?.type,
        value: "",
      },
    ]);
  };

  const handleRemoveDiscount = (id) => {
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id)
      );
    }
  };

  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const handleDiscountTypeChange = (field, value) => {
    const formDiscount = formData?.discounts || [];
    const updatedDiscounts = formDiscount.map((data) => ({
      ...data,
      [field]: value, // Update the specific field for all discounts
    }));
    setFormData({
      ...formData,
      discounts: updatedDiscounts,
    });
  };
  // const showFeilds = () => {
  //   if (
  //     formData.createInvoiceBy === "By Client" ||
  //     formData.createInvoiceBy === "Manual"
  //   ) {
  //     return !!formData.client;
  //   } else {
  //     return !!formData.employees;
  //   }
  // };
  const showFeilds = () => {
    if (
      formData.createInvoiceBy === 2
      // formData.createInvoiceBy === "Manual"
    ) {
      return !!formData.client;
    } else {
      return !!formData.employees;
    }
  };
  console.log("tableData", tableData);
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      // Helpers to reduce repetition
      const parseAddress = (str) => {
        const parts = str?.split(",") || [];
        return {
          address1: parts[0]?.trim() || "",
          address2: parts[1]?.trim() || "",
          city: parts[2]?.trim() || "",
          state: parts[3]?.trim() || "",
          country: parts[4]?.trim() || "",
          zipCode: parts[5]?.trim() || "",
        };
      };
      const toCommaSeparated = (val) => {
        const arr = Array.isArray(val) ? val : (typeof val === "string" && val ? [val] : []);
        const joined = arr.filter(Boolean).join(",");
        return joined ? [joined] : [];
      };

      const createInvoice = {
        amounts: {
          invoiced: calculateDiscountedTotal(
            tableAmountTotal,
            formData?.discounts
          ),
          due: currentInvoices?.amounts?.due ?? 0,
          // due, received can be added here
        },
        serviceSummary: tableData,
        finalBill: {
          subTotal: tableAmountTotal,
          discounts: formData?.discounts,
        },
        notes: formData?.notes,
        consultantName: formData?.consultantName,
        invoiceDate: formData?.invoiceDate,
        shippedDate: formData?.shippedDate,
        dueDate: formData?.dueDate,

        // ✅ Newly added non-amount editable fields
        netTerms: formData?.netTerms?.value ?? formData?.netTerms,
        poNum: formData?.pONumber,
        memo: formData?.statementMemo,
        additionalInfo: formData?.additionalInfo,
        address: {
          billing: parseAddress(formData?.billingAddress),
          from: parseAddress(formData?.fromAddress),
        },
        inclPOEmail: !!formData?.includePOAttachment?.[0],
        inclNotesPdf: !!formData?.includeNotesInInvoice?.[0],
        memoPeriod: {
          from: formData?.statementfromToDate?.from,
          to: formData?.statementfromToDate?.to,
        },
        recipients: {
          to: toCommaSeparated(formData?.contactEmail),
          cc: toCommaSeparated(formData?.ccEmail),
          bcc: toCommaSeparated(formData?.bccEmail),
        },
      };

      // ✅ Clean data
      const submissionData = filterEmptyValues(createInvoice);
      // ✅ Filter attachments
      const cleanAttachments = Array.isArray(tableData)
        ? tableData.filter(
            (att) => Array.isArray(att.attachment) && att.attachment.length > 0
          )
        : [];
      const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
        doc.attachment.map((file) => {
          file.id = doc.id; // add or overwrite id property
          return file; // return updated file object
        })
      );
      // ✅ Helper to dispatch the invoice update
      const dispatchUpdate = (finalData) => {
        dispatch(
          addInvoicesStart({
            coll: "Invoice",
            uiid: currentInvoices?.uiid,
            postActions: ["AddToTimesheet"],
            payload: [{ type: "SET", value: { ...finalData, _skipFlatten: ["serviceSummary"] } }],
            onSuccess: () => {
              showToast("Invoice updated successfully", "success", 3000);
              dispatch(
                getCurrentInvoiceStart({
                  filters: { uiid: { type: "NONE", value: currentInvoices?.uiid } },
                  coll: "Invoice",
                  ref: "Client Employee Placement Timesheet",
                  incl: ["", "firstName lastName", "", "attachments"],
                })
              );
              onBack();
            },
          })
        );
      };

      // ✅ Dispatch based on whether there are attachments
      if (cleanAttachmentsFiles.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            entity: "invoices",
            uiid: currentInvoices?.uiid,
            category: "ServiceSummaryDocuments",
            coll: "Invoice",
            doc: cleanAttachmentsFiles,
            onSuccess: (fileData) => {
              const updatedServiceSummary = submissionData.serviceSummary?.map(
                (data) => {
                  const matchedFile = fileData.find(
                    (f) => f?.fileRefId === data.id && f.key
                  );
                  return {
                    ...data,
                    attachments: matchedFile ? [matchedFile.key] : [],
                  };
                }
              );
              dispatchUpdate({ ...submissionData, serviceSummary: updatedServiceSummary });
            },
          })
        );
      } else {
        dispatchUpdate(submissionData);
      }

      // onBack();
    }
  };
  const handleCallInvoiceApi = async () => {
    const invoices = currentInvoices?.jobId?.invoices || {};
    const { frequency, frequencyStartDay } = invoices;
    const placementId = currentInvoices?.jobId?.uiid;
    const apexDates = currentInvoices?.jobId?.apexDates;
    const timesheetRef = currentInvoices?.timesheetRef || [];
    const uiids = timesheetRef.map((item) => item.id) || [];
    console.log("uiids", uiids);
    if (uiids.length === 0) {
      return "";
    }
    let filters = {
      // periodCycle: { type: "NONE", value: periodCycle },
      uiid: { type: "IN", value: uiids },
      // status: { type: "NONE", value: 3 },
      dailyEntries: { type: "ELEM_EXISTS", value: ["invoiceId", true] },
    };
    try {
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.TIMESHEETS.GET_ALL,
        params: {
          coll: "Timesheet",
          fil: JSON.stringify(filters),
          cache: false,
          ret: "period dailyEntries uiid  status",
          sort: JSON.stringify({ uiid: -1 }),
        },
      });
      const timeSheetData = response?.data?.data || [];
      console.log("timeSheetData", timeSheetData);
      const filteredData = timeSheetData
        .filter((item) =>
          timesheetRef.some((myItem) => myItem.id === item.uiid)
        ) // Match uiid with id
        .map((item) => {
          const matchedItem = timesheetRef.find(
            (myItem) => myItem.id === item.uiid
          );
          const filteredEntries = item.dailyEntries.filter((entry) =>
            matchedItem.dates.includes(entry.date)
          );
          return {
            ...item,
            dailyEntries: filteredEntries, // Attach only filtered dailyEntries
          };
        });
      const mergeEntriesData = mergeEntries(filteredData);
      console.log("filteredData", filteredData);
      console.log("mergeEntriesData", mergeEntriesData);

      setSelectTimeSheetOriganalData(timeSheetData);
      const dateRange = await splitByCase(
        mergeEntriesData,
        frequency,
        frequencyStartDay,
        currentInvoices?.frequencyPeriod,
        apexDates
      );
      const companyName = currentInvoices?.clientId?.businessName;
      const userFirstName = currentInvoices?.employeeId?.firstName;
      console.log("dateRange", dateRange);
      const combinedData = await mapDailyEntriesToRanges(
        mergeEntriesData || [],
        dateRange || [],
        frequency,
        companyName,
        userFirstName
      );
      const filteredCombinedData = combinedData
        .map((item) => {
          const validRanges = Array.isArray(item.ranges)
            ? item.ranges.filter(
                (r) =>
                  Array.isArray(r.dailyEntries) && r.dailyEntries.length > 0
              )
            : [];

          if (validRanges.length > 0) {
            return { ...item, ranges: validRanges };
          }
          return null; // Exclude this item later if no valid ranges
        })
        .filter(Boolean); // Remove null items
      setSelectedValues(filteredCombinedData?.[0]?.ranges || []);
      setSelectTimeSheetData(filteredCombinedData);
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };
  useEffect(() => {
    if (formData.netTerms && formData.invoiceDate) {
      const number = String(
        formData?.netTerms?.value ?? formData?.netTerms ?? "0"
      ).match(/\d+/);
      const extractedNumber = number ? parseInt(number[0], 10) : null;
      if (extractedNumber !== null) {
        // Convert invoiceDate to Date object
        const invoiceDate = new Date(formData?.invoiceDate);
        // Add the extracted number of days to the invoiceDate
        invoiceDate.setDate(invoiceDate.getDate() + extractedNumber);
        // Format the dueDate (YYYY-MM-DD format)
        const dueDate = invoiceDate.toISOString().split("T")[0]; // "YYYY-MM-DD"
        // Update the dueDate
        handleChange("dueDate", dueDate);
      }
    }
  }, [formData.netTerms, formData.invoiceDate]);

  console.log("currentInvoices", currentInvoices);
  useEffect(() => {
    if (currentInvoices) {
      handleChange("createInvoiceBy", currentInvoices?.invoiceCreatedBy);
      handleChange("invoiceDate", currentInvoices?.invoiceDate);
      handleChange("shippedDate", currentInvoices?.shippedDate);
      handleChange("dueDate", currentInvoices?.dueDate);
      handleChange("invoiceNumber", currentInvoices?.invoiceNum);
      handleChange("pONumber", currentInvoices?.poNum || defaultValues.pONumber);
      handleChange("netTerms", currentInvoices?.netTerms || defaultValues.netTerms);
      handleChange("statementMemo", currentInvoices?.memo || defaultValues.statementMemo);
      handleChange("notes", currentInvoices?.notes || defaultValues.notes);
      handleChange("additionalInfo", currentInvoices?.additionalInfo || defaultValues.additionalInfo);
      handleChange(
        "billingAddress",
        [
          currentInvoices?.address?.billing?.address1 || "",
          currentInvoices?.address?.billing?.address2 || "",
          currentInvoices?.address?.billing?.city || "",
          currentInvoices?.address?.billing?.state || "",
          currentInvoices?.address?.billing?.country || "",
          currentInvoices?.address?.billing?.zipCode || "",
        ]
          .filter(Boolean) // Remove any empty strings
          .join(", ") || defaultValues.billingAddress
      );
      handleChange(
        "fromAddress",
        [
          currentInvoices?.address?.from?.address1 || "",
          currentInvoices?.address?.from?.address2 || "",
          currentInvoices?.address?.from?.city || "",
          currentInvoices?.address?.from?.state || "",
          currentInvoices?.address?.from?.country || "",
          currentInvoices?.address?.from?.zipCode || "",
        ]
          .filter(Boolean)
          .join(", ") || defaultValues.fromAddress
      );

      handleChange("consultantName", currentInvoices?.consultantName || defaultValues.consultantName);
      handleChange("client", currentInvoices?.clientId?.businessName);
      handleChange("employees", currentInvoices?.employeeId?.firstName);
      if (currentInvoices?.memoPeriod) {
        handleChange("statementfromToDate", currentInvoices?.memoPeriod);
      }
      handleChange(
        "includePOAttachment",
        currentInvoices?.inclPOEmail === true ? [true] : defaultValues.includePOAttachment
      );
      handleChange(
        "includeNotesInInvoice",
        currentInvoices?.inclNotesPdf === true ? [true] : defaultValues.includeNotesInInvoice
      );
      //  id: uuidv4(),
      const discountsData = currentInvoices?.finalBill?.discounts || [];
      const updatedDiscountsData = discountsData.map((data) => ({
        ...data,
        id: uuidv4(), // Assigning a new unique id to each item
      }));
      handleChange("discounts", updatedDiscountsData);
      // Split comma-separated email strings into individual emails
      const splitEmails = (val) => {
        if (!val) return [];
        const arr = Array.isArray(val) ? val : [val];
        return arr
          .filter(Boolean)
          .flatMap((item) => (typeof item === "string" ? item.split(",") : [item]))
          .map((e) => (typeof e === "string" ? e.trim() : e))
          .filter(Boolean);
      };
      const initTo = splitEmails(currentInvoices?.recipients?.to);
      const initCc = splitEmails(currentInvoices?.recipients?.cc);
      const initBcc = splitEmails(currentInvoices?.recipients?.bcc);
      
      handleChange("contactEmail", initTo.length ? initTo : defaultValues.contactEmail);
      handleChange("ccEmail", initCc.length ? initCc : defaultValues.ccEmail);
      handleChange("bccEmail", initBcc.length ? initBcc : defaultValues.bccEmail);
      //  id: uuidv4(),
      const serviceSummaryData = currentInvoices?.serviceSummary || [];
      const updatedData = serviceSummaryData.map((data) => ({
        ...data,
        id: uuidv4(), // Assigning a new unique id to each item
        editable: true,
        delete: true,
      }));
      console.log("updatedData", updatedData);
      setTableData(updatedData);
      handleCallInvoiceApi();
    }
  }, [currentInvoices]);
  console.log("currentInvoices?.memoPeriod", currentInvoices?.memoPeriod);
  console.log("statementMemoFromTo", formData?.statementMemoFromTo);
  const handleSelectTimeDate = (e) => {
    setSelectedValues(e);
    const timeData = e;
    const value = [];
    const userFirstName = currentInvoices?.employeeId?.firstName;
    timeData.forEach((data) => {
      const dailyEntries = data.dailyEntries || [];
      const totalHours = dailyEntries.reduce(
        (sum, entry) => sum + (entry.st || 0),
        0
      );
      const form = new Date(data.from).toLocaleDateString();
      const to = new Date(data.to).toLocaleDateString();
      const payments =
        currentInvoices?.jobId?.payments?.[
          currentInvoices?.jobId?.payments?.length - 1
        ] || {};

      const amount = totalHours * (payments?.billRate?.rate || 0);
      value.push({
        id: uuidv4(),
        ss: userFirstName,
        rate: payments?.billRate?.rate || 0,
        activity: `${form} - ${to}`,
        fromDates: {
          from: data.from,
          to: data.to,
        },
        quantity: totalHours,
        amount: amount,
        editable: false,
        delete: true,
        tableSheetData: true,
      });
    });
    console.log("value", value);
    const group1 = tableData.filter(
      (row) => row.editable === false && row.delete === false
    );
    const group2 = tableData.filter(
      (row) => row.editable === true && row.delete === true
    );

    let updateData = [];

    if (value.length) {
      // Update group1 entries with values
      const updatedGroup1 = group1.map((data, index) => {
        const newValue = value[index] || value[0]; // fallback to value[0] if not enough
        handleChange("statementMemoFromTo", newValue.fromDates);
        return {
          ...data,
          activity: newValue.activity,
          quantity: newValue.quantity,
          amount: newValue.amount,
          rate: newValue.rate,
        };
      });
      // Remaining values that were not used for group1
      const remainingValues = value.slice(group1.length);
      updateData = [...updatedGroup1, ...group2, ...remainingValues];
    } else {
      const resetGroup1 = group1.map((data) => ({
        ...data,
        rate: 0,
        activity: "",
        quantity: 0,
        amount: 0,
      }));
      handleChange("statementMemoFromTo", "");
      updateData = [...resetGroup1, ...group2];
    }
    setSelectedValues(e);
    setTableData(updateData);
  };
  console.log("includeNotesInInvoice", formData?.includeNotesInInvoice);
  return (
    <div className="flex gap-2 overflow-auto w-full">
      <div
        className={`border-[1px] border-neutrals-50 rounded p-3 mt-2 ${
          showSideBar ? "w-[80%]" : "w-full"
        }`}
      >
        <div className="flex justify-between">
          <PageHeader
            Section={
              <div className="flex">
                <Button
                  // type="icon"
                  className="pl-0!"
                  variant="text"
                  color="black"
                  icon={"arrow_left_alt"}
                  onClick={onBack}
                  title="Edit Invoice"
                />
                {/* <PageTitle title="Edit Invoice" tag="p" /> */}
              </div>
            }
          />
          {/* <p>Edit Invoice</p> */}

          {/* <Button
            title={"View Awaiting Invoices"}
            icon={"arrow_right_alt"}
            iconPosition="after"
            // onClick={() => {}}
          /> */}
        </div>

        <div className="flex flex-col-reverse xl:flex-row mt-3 gap-9">
          <div
            className={`grid ${
              showSideBar ? "grid-cols-3" : "grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            } gap-x-6 gap-y-8 mt-3 flex-1`}
          >
            <FormFieldSet
              type="select"
              title="Create Invoice By"
              placeholder="Select Create Invoice By"
              value={formData.createInvoiceBy}
              onChange={(value) => {
                handleChange("createInvoiceBy", value);
                handleChange("client", "");
                handleChange("employees", "");
                handleChange("invoiceFrequency", "");
                setFormData({
                  ...defaultValues,
                  createInvoiceBy: value,
                });
                setTableData([]);
                handleChange("fromToDate", "");
                handleChange("intervals", "");
                setShowSideBar(false);
                setSelectTimeSheetData([]);
                setSelectTimeSheetOriganalData([]);
                setSelectedValues([]);
              }}
              error={errors.createInvoiceBy}
              options={CreateInvoiceByOptions}
              disabled={true}
            />
            {/* Conditional field order */}
            {[1, 3].includes(formData.createInvoiceBy) ? (
              <>
                <FormFieldSet
                  type="allClientsList"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  onChange={(value) => {
                    handleChange("employees", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("client", value);

                    setTableData([]);
                    setSelectTimeSheetData([]);
                    setSelectTimeSheetOriganalData([]);
                    setSelectedValues([]);
                  }}
                  error={errors.client}
                  options={InvoiceClientOptions}
                  showSearch
                  // disabled={!formData.createInvoiceBy}
                  // onSelectItem={(options, data, value) =>
                  //   handleSelectClientNVender(options, data, value)
                  // }
                  disabled={true}
                />
                <FormFieldSet
                  type="select"
                  title="Invoice Frequency"
                  placeholder="Select Invoice Frequency"
                  value={formData.invoiceFrequency}
                  onChange={(value) => {
                    handleChange("invoiceFrequency", value);

                    if (value === "By Dates") {
                      handleChange("fromToDate", "");
                      setShowfromToDate(true);
                      setShowSideBar(false);
                    } else if (value === "By System Intervals") {
                      handleChange("fromToDate", "");
                      handleChange("intervals", "");
                      setShowfromToDate(false);
                      setShowSideBar(true);
                    }
                  }}
                  error={errors.invoiceFrequency}
                  options={InvoiceFrequencyOptions}
                  disabled={true}
                  // disabled={frequencyNumber !== 5}
                />
                <FormFieldSet
                  type="employeePlacements"
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("employees", value);
                  }}
                  error={errors.employees}
                  placementUiid={placementsUiid}
                  entityType={entityType}
                  refCollection={"PlacementWithClient"}
                  ret={
                    "firstName middleName lastName email.primary uiid placements"
                  }
                  // onSelectItem={(options, data, value) =>
                  //   handleSelectEmployeeNPlacement(
                  //     options,
                  //     data,
                  //     value,
                  //     "client"
                  //   )
                  // }
                  disabled={true}
                />
              </>
            ) : (
              <>
                {/* Employees First */}
                <FormFieldSet
                  type="employeeClients"
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("client", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("employees", value);
                    setTableData([]);
                    setSelectTimeSheetData([]);
                    setSelectTimeSheetOriganalData([]);
                    setSelectedValues([]);
                  }}
                  error={errors.employees}
                  options={InvoiceEmployeesOptions}
                  showSearch
                  ret={"placements firstName uiid"}
                  refCollection={"PlacementWithClient"}
                  disabled={!formData.createInvoiceBy}
                  // onSelectItem={(options, data, value) =>
                  //   handleSelectEmployeeNPlacement(options, data, value)
                  // }
                />

                {/* Invoice Frequency */}
                <FormFieldSet
                  type="select"
                  title="Invoice Frequency"
                  placeholder="Select Invoice Frequency"
                  value={formData.invoiceFrequency}
                  // onChange={(value) => handleChange("invoiceFrequency", value)}
                  onChange={(value) => {
                    handleChange("invoiceFrequency", value);

                    if (value === "By Dates") {
                      handleChange("fromToDate", ""); // reset intervals
                      setShowfromToDate(true); // open modal
                      setShowSideBar(false); // wait for Save
                    } else if (value === "By System Intervals") {
                      handleChange("fromToDate", "");
                      handleChange("intervals", ""); // reset dates
                      setShowfromToDate(false); // close modal
                      setShowSideBar(true); // show sidebar immediately (optional: only after interval is selected)
                    }
                  }}
                  error={errors.invoiceFrequency}
                  options={InvoiceFrequencyOptions}
                  disabled={true}
                  // disabled={!formData.createInvoiceBy}
                  // disabled={frequencyNumber !== 5}
                />
                <FormFieldSet
                  type="select"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  uiid={1}
                  // onChange={(value) => handleSelectClientPlacement(value)}
                  error={errors.client}
                  // showButton
                  showSearch
                  options={selectClientOptions}
                  disabled={true}
                />
              </>
            )}
          </div>

          <div className="flex justify-end">
            <div className="ml-8 min-w-60">
              {/* <InfoTimeCardAdv
                title="Total Due"
                value={currentInvoices?.amounts?.due ?? 0}
                prefix=""
                suffix="USD"
                color="primary"
                size="sm"
              /> */}
              <InfoCardNewAdv
                layout="option12"
                title="Total Due"
                value={currentInvoices?.amounts?.due ?? 0}
                valueConfig={{ className: "text-[24px]!", decimals: 2 }}
                suffixConfig={{
                  className: "mt-1 justify-end! item-end! font-normal!",
                }}
                suffix="USD"
              />
            </div>
          </div>
        </div>
        {/* {showFeilds() && ( */}
        <>
          <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 mt-4 ">
            <FormFieldSet
              type="textArea"
              title={"Billing Address"}
              placeholder="45"
              value={formData.billingAddress}
              onChange={(value) => handleChange("billingAddress", value)}
              error={errors.billingAddress}
              rows={5}
              // disabled={true}
            />
            <FormFieldSet
              type="textArea"
              title={"From Address"}
              placeholder="45"
              value={formData.fromAddress}
              onChange={(value) => handleChange("fromAddress", value)}
              error={errors.fromAddress}
              rows={5}
              // disabled={true}
            />
          </div>

          <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 mt-4">
            <FormFieldSet
              // type="netTerm"
              type="select"
              title={"Net Terms"}
              placeholder="Select Net Terms"
              options={netTermsOptions}
              value={formData.netTerms}
              onChange={(value) => handleChange("netTerms", value)}
              error={errors.netTerms}
              // showButton
              showSearch
              // disabled={true}
            />
            <FormFieldSet
              type="datepicker"
              title={"Invoice Date"}
              placeholder="04/04/2025"
              value={formData.invoiceDate}
              onChange={(value) => handleChange("invoiceDate", value)}
              error={errors.invoiceDate}
              // disabled={true}
              showDropdown={false}
            />
            <FormFieldSet
              type="datepicker"
              title={"Shipped Date"}
              placeholder="45"
              value={formData.shippedDate}
              onChange={(value) => handleChange("shippedDate", value)}
              error={errors.shippedDate}
              // disabled={true}
              showDropdown={false}
            />
            <FormFieldSet
              type="datepicker"
              title={"Due Date"}
              placeholder="Select Due Date"
              value={formData.dueDate}
              onChange={(value) => handleChange("dueDate", value)}
              error={errors.dueDate}
              showDropdown={false}
              // disabled={true}
            />
            {/* <FormFieldSet
                type="text"
                title={"Location"}
                placeholder="Enter Location"
                value={formData.location}
                onChange={(value) => handleChange("location", value)}
                error={errors.location}
              />
              <FormFieldSet
                type="text"
                title={"Class"}
                placeholder="Enter"
                value={formData.class}
                onChange={(value) => handleChange("class", value)}
                error={errors.class}
              /> */}
            <FormFieldSet
              type="text"
              title={"Invoice Number"}
              placeholder="16464"
              value={formData.invoiceNumber}
              onChange={(value) => handleChange("invoiceNumber", value)}
              error={errors.invoiceNumber}
              disabled={true}
            />
            <FormFieldSet
              type="text"
              title={"PO Number"}
              placeholder="45"
              value={formData.pONumber}
              onChange={(value) => handleChange("pONumber", value)}
              error={errors.pONumber}
              // disabled={true}
            />
            <FormFieldSet
              type="checkbox"
              size={"md"}
              title={""}
              options={[
                {
                  label: "Include PO Attachment in Email",
                  value: true,
                },
              ]}
              values={formData.includePOAttachment || []}
              onChange={(value) => handleChange("includePOAttachment", value)}
              multiple
              error={errors.includePOAttachment}
              // disabled={true}
            />
          </div>
          <div className="mt-6">
            <p>Invoice Attachments</p>
            <Divider />
            <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 mt-6">
              <FormFieldSet
                type={"email"}
                title={"Contact Email(s)"}
                value={formData.contactEmail}
                onChange={(value) => handleChange("contactEmail", value)}
                error={errors.contactEmail}
                multiple
                // disabled={true}
              />
              <FormFieldSet
                type={"email"}
                title={"CC Email(s)"}
                value={formData.ccEmail}
                onChange={(value) => handleChange("ccEmail", value)}
                error={errors.ccEmail}
                multiple
                // disabled={true}
              />
              <FormFieldSet
                type={"email"}
                title={"BCC Email(s)"}
                placeholder="Enter Email"
                value={formData.bccEmail}
                onChange={(value) => handleChange("bccEmail", value)}
                error={errors.bccEmail}
                multiple
                // disabled={true}
              />
              <FormFieldSet
                type="text"
                title={"Consultant Name"}
                value={formData.consultantName}
                onChange={(value) => handleChange("consultantName", value)}
                error={errors.consultantName}
                // disabled={true}
              />
            </div>
          </div>
        </>
        {/* )} */}
        <div>
          <div className="flex justify-between mt-6 mb-1 items-end">
            <p>Service Summary</p>
            <Button
              title="Add"
              color="black"
              icon="add"
              // onClick={handleAddRow}
              disabled={true}
            />
          </div>
          <Divider />
          <div className="mt-3">
            <NewTable rows={tableData} columns={columns} hideToolBar showSlNo />
          </div>
        </div>
        <div className="mt-4">
          <p>Notes & Total </p>
          <Divider />
        </div>
        <div className=" mt-2">
          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-2">
              Subtotal:
              <div className="bg-black text-white pl-3 pr-2 py-2">
                {tableAmountTotal} USD
              </div>
            </div>
            <div className="flex flex-col gap-4 items-start w-full">
              {formData.discounts.map((discount, index) => (
                <div key={discount.id} className="grid grid-cols-[repeat(3,1fr)] items-start lg:grid-cols-[repeat(3,1fr)] xl:grid-cols-[repeat(4,1fr)_1.2fr] gap-6 mt-3 w-full">
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      noTitle={true}
                      value={discount.name}
                      placeholder="Name"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "name", value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="select"
                      noTitle={true}
                      value={discount.type}
                      placeholder="Select"
                      onChange={(value) =>
                        handleDiscountTypeChange("type", value)
                      }
                      disabled={index !== 0}
                      options={[
                        { label: "Percentage", value: 1 },
                        { label: "Value", value: 2 },
                      ]}
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="Discount"
                      noTitle={true}
                      value={discount.value}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "value", value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="comment"
                      noTitle={true}
                      value={discount.comment}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "comment", value)
                      }
                    />
                  </div>
                  <div className="mt-3 flex gap-2 items-center">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      onClick={handleAddDiscount}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      onClick={() => handleRemoveDiscount(discount.id)}
                    />
                  </div>
                  <div className="text-gray-600 mt-3">
                    {formatDiscountDisplay(discount, tableAmountTotal)} USD
                  </div>
                </div>
              ))}
            </div>
            <div className="flex gap-2 mt-3">
              discount Total:
              <div>
                {calculateTotalDiscountInvoice(
                  formData?.discounts,
                  tableAmountTotal
                )}
                USD
              </div>
            </div>
            <div className="min-w-72 ">
              <Divider />
              <div className="flex justify-end ">
                <p>
                  Grand Total{" "}
                  <span className="ml-7">
                    {calculateDiscountedTotal(
                      tableAmountTotal,
                      formData.discounts
                    )}{" "}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 flex-1 mt-4">
          <FormFieldSet
            type="textArea"
            title="Notes"
            value={formData.notes}
            onChange={(value) => handleChange("notes", value)}
            error={errors.notes}
          />
          <FormFieldSet
            type="text"
            title="Statement Memo"
            value={formData.statementMemo}
            onChange={(value) => handleChange("statementMemo", value)}
            error={errors.statementMemo}
            // disabled={true}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 mt-2">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "Include Notes in invoice PDF",
                value: true,
              },
            ]}
            values={formData.includeNotesInInvoice || []}
            onChange={(value) => handleChange("includeNotesInInvoice", value)}
            multiple
            error={errors.includeNotesInInvoice}
            // disabled={true}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8 mt-6">
          <div>
            {/* <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title="Statement Memo Period From"
                value={formData.statementMemoFrom}
                onChange={(value) => handleChange("statementMemoFrom", value)}
                error={errors.statementMemoFrom}
              />
            </div>

            <div className="mt-6">To</div>
            <div className="flex-1 ">
              <FormFieldSet
                type="datepicker"
                title=""
                value={formData.statementMemoTo}
                onChange={(value) => handleChange("statementMemoTo", value)}
                error={errors.statementMemoTo}
              />
            </div> */}
            <FormFieldSet
              type="datepickerRange"
              title="Statement Memo Period From"
              placeholder="Select From and To Date"
              value={formData.statementfromToDate}
              onChange={(val) => handleChange("statementfromToDate", val)}
              // disabled={true}
            />
          </div>
          {/* <FormFieldSet
            type="select"
            title="Invoice Category"
            placeholder="Select Invoice Category"
            value={formData.invoiceCetegoty}
            onChange={(value) => handleChange("invoiceCetegoty", value)}
            error={errors.invoiceCetegoty}
          />
          <FormFieldSet
            type="file"
            title="Attachment"
            placeholder="Choose File"
            value={formData.attachment}
            onChange={(value) => handleChange("attachment", value)}
            error={errors.attachment}
          />
          <FormFieldSet
            type="textArea"
            title="Payable To"
            value={formData.payableTo}
            onChange={(value) => handleChange("payableTo", value)}
            error={errors.payableTo}
          /> */}
        </div>
        <div className="mt-4">
          <p>Additional Info </p>
          <Divider />
          <div className="border-[1px] border-neutrals-50 rounded p-3 min-h-[250px] ">
            <FormFieldSet
              type="textArea"
              title=""
              value={formData.additionalInfo}
              onChange={(value) => handleChange("additionalInfo", value)}
              error={errors.additionalInfo}
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 my-6">
          <Button title={"Cancel"} variant="outlined" />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
        {formData.invoiceFrequency === "By Dates" && (
          <FromToDateModal
            isOpen={showfromToDate}
            onClose={() => setShowfromToDate(false)}
            value={formData.fromToDate}
            onChange={(val) => handleChange("fromToDate", val)}
            onSave={(val) => {
              if (val?.from && val?.to) {
                handleChange("fromToDate", val);
                setShowSideBar(true);
                setShowfromToDate(false);
              }
            }}
          />
        )}
      </div>
      {/* <MoreActionModal
        open={moreActionModal}
        onClose={() => setMoreActionModal(!moreActionModal)}
      /> */}

      {selectTimeSheetData.length > 0 && (
        <div className="border-[1px] border-neutrals-50 rounded p-3 mt-2 w-[20%]">
          <InvoiceSidebar
            data={selectTimeSheetData}
            selectedValues={selectedValues}
            handleSelectTimeDate={handleSelectTimeDate}
            disabled={true}
          />
        </div>
      )}
    </div>
  );
};

export default EditInvoice;
